module.exports = __webpack_public_path__ + "static/media/BeginnerGuidePic.e5188898.png";